import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../services/authConfig';
import './Login.css';
import GodrejLogo from '../assets/images/Godrej_Logo.png';
import api from '../services/api';

const SAFE_ID_REGEX = /^[a-zA-Z0-9]*$/;

function Login({ onLogin }) {
  const { instance } = useMsal();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState('');

  const handleUserIdChange = (e) => {
    const val = e.target.value;
    if (SAFE_ID_REGEX.test(val)) setUserId(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!SAFE_ID_REGEX.test(userId) || !userId.trim()) {
      setError('User ID contains invalid characters');
      return;
    }
    setLoading(true);

    try {
      const { data } = await api.post('/auth/login', { user_id: userId.trim() });
      onLogin(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleSSOLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error('SSO Error:', err);
      setError(err.response?.data?.error || err.message || 'SSO login failed');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <div className="logo-section">
          <img src={GodrejLogo} alt="Godrej" className="godrej-logo" />
        </div>
        <div className="company-text">
          <span>Godrej Enterprises Group</span>
        </div>
      </header>
      <div className="login-container">
        <div className="login-box">
          <div className="title-section">
            <h1 className="main-title">AMS</h1>
            <h2 className="sub-title">Asset Management System</h2>
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="button" className="sso-button" onClick={handleSSOLogin} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in with Microsoft'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
